import { RawBusinessUnit } from "@buzzeasy/shared-frontend-utilities/agentHubEvents";
import { createContext } from "react";
import { AgentState } from "../../models/agent";
import { Application } from "../../models/misc";

interface ExtendedAgentState extends AgentState {
  applications: Application[];
  businessUnits: RawBusinessUnit[];
}

export type AgentStateContextValue = [
  /**
   * The current state of the agent.
   */
  state: ExtendedAgentState,
  /**
   * Actions to modify the agent state.
   */
  actions: {
    launchApplication(app: Application): void;
    closeApplication(appName: Application["appId"]): void;
  },
];

export const defaultAgentState: AgentState = {
  stateSince: new Date(),
  status: "Break",
  breakName: null,
  breakBusinessUnitId: null,
  timedBreakExpiresAt: null,
  allowAgentsToSelectBusinessUnits: false,
  disableCustomerCreation: false,
  disableCustomerEdit: false,
  workItems: [],
};

export const AgentStateContext = createContext<AgentStateContextValue>([
  { ...defaultAgentState, applications: [], businessUnits: [] },
  { launchApplication: () => { }, closeApplication: () => { } },
]);
